import React from 'react';
import { CustomStyleWarningLegend } from './Styles';
import {Box} from "@mui/material";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description
 * CustomWarningLegend is a reusable component for displaying a warning message
 * or any content with a yellow background style to highlight information.
 *
 * @param {JSX.Element} children - The content to display inside the warning box (text or JSX).
 * @param {string} classes - Optional additional CSS utility classes to control layout (default is "d-flex").
 *
 * @returns {JSX.Element} - A styled Box component containing the given children.
 */

const CustomWarningLegend = ({ children, classes = "d-flex" }) => {
    return (
        <Box
            className={"my-2 justify-content-center text-center mb-4 " + classes}
            sx={CustomStyleWarningLegend}
        >
            {children}
        </Box>
    );
};

export default CustomWarningLegend;
